"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthoriserBase = exports.useAuthoriser = void 0;
const initializer_1 = require("../../../initializer");
const useAuthoriserBase_hook_1 = require("./useAuthoriserBase.hook");
Object.defineProperty(exports, "useAuthoriserBase", { enumerable: true, get: function () { return useAuthoriserBase_hook_1.useAuthoriserBase; } });
const useAuthoriser = (props = {}) => (0, useAuthoriserBase_hook_1.useAuthoriserBase)({ authoriser: initializer_1.Authoriser, ...props });
exports.useAuthoriser = useAuthoriser;
//# sourceMappingURL=useAuthoriser.hook.js.map